const zh_abilities = {
  flm_rs      : '火屬性抗性',
  wtr_rs      : '水屬性抗性',
  wnd_rs      : '風屬性抗性',
  lgh_rs      : '光屬性抗性',
  shd_rs      : '闇屬性抗性',

  afl_grd     : '異常狀態無效',
  psn_rs      : '毒抗性',
  brn_rs      : '火燒抗性',
  frz_rs      : '凍結抗性',
  prl_rs      : '麻痺抗性',
  bln_rs      : '黑暗抗性',
  stn_rs      : '昏厥抗性',
  crs_rs      : '詛咒抗性',
  bg_rs       : '濕身抗性',
  slp_rs      : '睡眠抗性',

  hmd_rs      : '真・碧龍抗性',
  md_rs       : '碧龍抗性',
  hbr_rs      : '真・緋龍抗性',
  br_rs       : '緋龍抗性',
  hmr_rs      : '真・青龍抗性',
  mr_rs       : '青龍抗性',
  hjp_rs      : '真・輝龍抗性',
  jp_rs       : '輝龍抗性',
  hzd_rs      : '真・闇龍抗性',
  zd_rs       : '闇龍抗性',

  hfl_str     : 'HP全滿・攻',
  hfl_dfn     : 'HP全滿・防',
  hfl_hl      : 'HP全滿・回復',
  hfl_skl_dmg : 'HP全滿・技能傷害',
  hfl_crt_rt  : 'HP全滿・爆擊',
  hfl_crt_dmg : 'HP全滿・爆擊威力',

  h70_str     : 'HP70%・攻',
  h70_dfn     : 'HP70%・防',
  h70_hl      : 'HP70%・回復',
  h70_skl_dmg : 'HP70%・技能傷害',
  h70_crt_rt  : 'HP70%・爆擊',
  h70_crt_dmg : 'HP70%・爆擊威力',

  str_dbb     : '守護之鏈・攻',
  hl_dbb      : '守護之鏈・治癒',
  enr_dbb     : '守護之鏈・活力',
  crt_dmg_dbb : '守護之鏈・爆擊威力',

  lst_ofn     : '背水之陣・攻',
  lst_dfn     : '背水之陣・防',
  lst_rcv     : '背水之陣・治癒',
  lst_crt_rt  : '背水之陣・爆擊',
  rsl_ofn     : '起死回生・攻',

  flr_str     : '疾風怒濤・攻',
  flr_dvs     : '疾風怒濤・爆擊',
  hts_elu     : '連擊活力提升',

  drg_dmg     : '龍化中傷害提升',
  drg_tm      : '龍化時間',
  drg_clw     : '龍族恩寵・攻',

  skl_prp     : '開場技能量條',
  shs_prp     : '開場龍化量條',
  enr_prp     : '開場活力提升',
  shl_prp     : '開場傷害・盾',

  skl_hst     : '技能累積',
  unt_hst     : '團結一致・技能累積',
  stk_hst     : '技能累積・強擊',
 
  frc_stk     : '爆發傷害',
  frc_chr     : '技能蓄集・強擊',

  ovd_pns     : 'Overdrive特攻',
  brk_pns     : 'BREAK特攻',
  psn_pns     : '毒特攻',
  brn_pns     : '火燒特攻',
  frz_pns     : '凍結特攻',
  prl_pns     : '麻痺特攻',
  bln_pns     : '黑暗特攻',
  stn_pns     : '昏厥特攻',
  crs_pns     : '詛咒特攻',
  bg_pns      : '濕身特攻',
  slp_pns     : '睡眠特攻',

  slyr_str    : '獅子奮迅・攻',
  stkr_str    : '爆發擊破・攻',

  gg_acl      : 'Overdrive削減',
  gg_inh      : 'Overdrive抑制',

  hp          : 'HP',
  skl_dmg     : '技能傷害',
  crt_rt      : '爆擊率',
  crt_dmg     : '爆擊威力',
  rcv_ptn     : '回復技能效果',
  bf_tm       : '增益效果時間',

  exp_1       : '星龍祭快樂！',
  exp_2       : '感受我的心',
  exp_3       : '包覆世界之歌'
}
export default zh_abilities